import { Injectable } from "@angular/core";
import { HttpClientService } from "src/app/http-confing/http/http-client.service";

interface CreateAgent {
  user: {
    username: string;
    email: string;
    password: string;
  };
  phones: number[];
  type: "residential" | "commercial" | "both";
  company_id: number;
  teams: number[];
  title_id: number;
}

interface UpdateAgent {
  agent_id: number;
  user_id: number;
  user: {
    username: string;
    email: string;
    password: string;
  };
  phones: number[];
  type: "residential" | "commercial" | "both";
  company_id: number;
  teams: string[];
  title_id: number;
}

@Injectable({
  providedIn: "root",
})
export class AgentsService {
  constructor(private http: HttpClientService) {}

  public createAgent(body: CreateAgent) {
    return this.http.post(body, "agent/create");
  }

  public getAllAgents(
    companyId: number,
    isPaginate: boolean = false,
    page?: number,
    search?: string
  ) {
    if (!isPaginate) {
      page = null;
    }
    return this.http.get("agent/get-all", {
      company_id: companyId,
      is_paginate: `${+isPaginate}`,
      page,
      search,
    });
  }
  public getAllAgentsByDates(
    dates,
    companyId: number,
    isPaginate: boolean = false,
    page?: number,
    search?: string
  ) {
    if (!isPaginate) {
      page = null;
    }
    return this.http.get("agent/get-all", {
      company_id: companyId,
      is_paginate: `${+isPaginate}`,
      page,
      search,
      from: dates.from,
      to: dates.to
    });
  }

  public getAgent(agentId: number) {
    return this.http.get("agent/get", { agent_id: agentId });
  }

  public updateAgent(body: UpdateAgent) {
    return this.http.post(body, "agent/update");
  }

  public deleteAgent(agentId: number) {
    return this.http.post({ agent_id: agentId }, "agent/delete");
  }
}
